import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
}

export const getters = {}

export const mutations = {
    SET_SERVICEAGREEMENTS(state, objects) {
        let updatedObjects = {}
        for (let key in objects) {
            if (!objects[key].deleted_at) {
                // Remove the '__typename' field that gets added by GraphQL
                delete objects[key].__typename
                // Stage the update so we can just do one Vue.set
                updatedObjects[objects[key].id] = objects[key]
            } else if (state.objects.hasOwnProperty(objects[key].id)) {
                // Immediately delete the object
                Vue.delete(state.objects, objects[key].id)
            }
        }
        state.objects = {
            ...updatedObjects,
        }
    },
    SET_SERVICEAGREEMENT(state, objects) {
        state.currentServiceAgreement = objects
    }
}


export const actions = {
    init({ commit, rootState }) {
        // Initialise the GraphQL client
        graphqlClient = createGraphQLClient(rootState)
    },

    async serviceAgreementById({ commit }, { id } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
          query serviceAgreementById($Id: ID!) {
            serviceAgreementById(id: $Id) {
              id
              gate_access_method
              notes
              agreement_commencement_date
              agreement_end_date
              delivery_date
              first_pickup
              client_id
              site_id
              files{
                id
                url
                filename
              }
              services{
              active
                service_title
                description
                service_type_id{
                    name
                }
                waste_type{
                    name
                }
              }
              site{
                id
                address
                contact_name
              }
              created_at
              updated_at
              deleted_at
            }
          }
        `,
                variables:{ Id: id }
            })
            commit('SET_SERVICEAGREEMENT', response.data.serviceById)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async serviceAgreementsByClientId({ commit }, { id } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
          query serviceAgreementsByClientId($Id: ID!) {
            serviceAgreementsByClientId(client_id: $Id) {
              id
              gate_access_method
              notes
              agreement_commencement_date
              agreement_end_date
              delivery_date
              first_pickup
              client_id
              site_id
              files{
                id
                url
                filename
              }
              services{
                id
                service_title
                active
                description
                schedule_string
                service_type_id{
                    name
                }
                waste_type{
                    name
                }
                service_bins{
                id
                price
                weekly_maintenance_fee
                extra_price
                bin{
                    id
                    price
                    capacity
                    description
                }
              }
                site{
                 trading_name
                 address
                 suburb
                 postcode
                 phone
                 mobile
                 email
                 contact_name
               }
              }
               site{
                trading_name
                 address
                 suburb
                 postcode
                 phone
                 mobile
                 email
                 contact_name
              }
              created_at
              updated_at
              deleted_at
            }
          }
        `,
                variables:{ Id: id }
            })
            commit('SET_SERVICEAGREEMENTS', response.data.serviceAgreementsByClientId)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async createServiceAgreement({ commit, dispatch }, {gateAccessMethod, clientId, siteId, notes, agreementCommencementDate, agreementEndDate ,deliveryDate, firstPickup} = {}) {
        try {
          await graphqlClient.mutate({
            mutation: gql`
              mutation createServiceAgreement(
                $GAM: String,
                $Client: ID,
                $Site: ID,
                $Notes: String,
                $ACD: String,
                $AED: String,
                $DD: String,
                $First: String
              ) {
                createServiceAgreement(
                  agreement: {
                    gate_access_method: $GAM,
                    client_id: $Client,
                    site_id: $Site,
                    notes: $Notes,
                    agreement_commencement_date: $ACD,
                    agreement_end_date: $AED
                    delivery_date: $DD,
                    first_pickup: $First
                  }
                ) {
                  id
                }
              }
            `,
            variables: { GAM: gateAccessMethod, Client: clientId, Site: siteId, Notes: notes, ACD: agreementCommencementDate,  AED: agreementEndDate, DD: deliveryDate, First: firstPickup },
          })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async updateServiceAgreement({ commit, dispatch }, {id, siteId, gateAccessMethod, notes, agreementCommencementDate, agreementEndDate, deliveryDate, firstPickup} = {}) {
      try {
        await graphqlClient.mutate({
          mutation: gql`
          mutation updateServiceAgreement(
            $agId: Int,
            $GAM: String,
            $Notes: String,
            $ACD: String,
            $AED: String,
            $DD: String,
            $First: String,
            $SiteId: ID
            ) {
              updateServiceAgreement(
                id: $agId,
                agreement:{
                  gate_access_method: $GAM,
                  notes: $Notes,
                  agreement_commencement_date: $ACD,
                  agreement_end_date: $AED
                  delivery_date: $DD,
                  first_pickup: $First,
                  site_id: $SiteId
                }
              ) {
                id
              }
            }
          `,
          variables: { agId: id, GAM: gateAccessMethod, Notes: notes, ACD: agreementCommencementDate,  AED: agreementEndDate, DD: deliveryDate, First: firstPickup, SiteId: siteId },
        }).then(() => {
          // // console.log(response)
        })
      } catch (ex) {
        console.error(ex)
        throw ex
      }
    },

    async deleteServiceAgreement({ commit }, { id } = {}) {
      try {
        await graphqlClient.mutate({
          mutation: gql`
            mutation DeleteServiceAgreement($Id: Int!) {
              deleteServiceAgreement(id: $Id) {
                id
              }
            }
          `,
          variables: { Id: id },
        })
        // commit('SET_SERVICEAGREEMENTS', response.data.deleteService)
      } catch (ex) {
        console.error(ex)
        throw ex
      }
    },

    async deleteAgreementDocument({ commit, dispatch }, {Id} = {}) {
      try {
        console.log(Id);
        await graphqlClient.mutate({
          mutation: gql`
          mutation removeAgreementDocument($Id: Int!)  {
            deleteServiceAgreementFile(id:$Id) {
              id
            }
          }
          `,
          variables: { Id: Id },
        }).then((response) => {
          console.log(response)
        })
      } catch (ex) {
        console.error(ex)
        throw ex
      }
    },
}
